import { createSelector } from '@opengov/compose-app/reselect';

import { launchDarklySelector } from './launchDarklyState';

export const selectFeatureFlags = createSelector(
  launchDarklySelector,
  state => {
    return state.flags;
  }
);

export const selectFeatureFlagStatus = createSelector(
  launchDarklySelector,
  state => {
    return state.featureFlagStatus;
  }
);

export const selectFeatureFlag = createSelector(selectFeatureFlags, (flags) => {
  return <FlagType = boolean>(flagName: string, notSetValue?: FlagType) => {
    return flags.get(flagName, notSetValue) as FlagType;
  };
});
